/*
 * Action types, for strong typing.
 */
export const SET_OUTBOUND_MESSAGE = 'SET_OUTBOUND_MESSAGE'

/*
 * Helper-functions for creating actions.
 */
export function setOutboundMessage(conversationId, message) {
  return { type: SET_OUTBOUND_MESSAGE, conversationId: conversationId, message: message }
}



// WEBPACK FOOTER //
// ./src/actions/outboundMessages.js